import { defineNuxtPlugin } from '#app'
import VueFlatPickr from 'vue-flatpickr-component'
// import 'flatpickr/dist/themes/dark.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('FlatPickr', VueFlatPickr)
})
